// 本规则来自 newsaas/docs/superpowers/specs/2026-06-22-weishop-chain-region-store-api-inventory.md。
// inventory 中 region_facade 唯一 API 有 223 条，这里按相同目标前缀压缩为业务族映射；
// safe_passthrough、plugin_passthrough_with_original_gate 与 excluded 先匹配，防止被宽前缀误改写。
export const regionMap = [
	{ from: "/api/weishop/admin/market/coupon", to: "/api/weishop/region/market/coupon" },
	{ from: "/api/weishop/admin/market/full", to: "/api/weishop/region/market/full" },
	{ from: "/api/weishop/admin/market/super", to: "/api/weishop/region/market/super" },
	{ from: "/api/weishop/admin/content/article/category/list", to: "/api/weishop/region/content/article/category/list" },
	{ from: "/api/weishop/admin/plugin/couponpack", to: "/api/weishop/region/market/couponpack" },
	{ from: "/api/weishop/admin/plugin/deposit/index", to: "/api/weishop/region/plugin/deposit/index" },
	{ from: "/api/weishop/admin/plugin/points/goods/listByIds", to: "/api/weishop/region/plugin/points/goods/listByIds" },
	{ from: "/api/weishop/admin/plugin/points/goods/index", to: "/api/weishop/region/plugin/points/goods/index" },
	{ from: "/api/weishop/admin/plugin/points/category/index", to: "/api/weishop/region/plugin/points/category/index" },
	{ from: "/api/weishop/admin/wechat-applyments", to: "/api/weishop/region/wechat-applyments" },
	{ from: "/api/weishop/admin/wechat-merchant-bindings", to: "/api/weishop/region/wechat-merchant-bindings" },
	{ from: "/api/weishop/store/store/wechat-applyment", to: "/api/weishop/region/store/wechat-applyment" },
	{ from: "/api/weishop/store/store/wechat-merchant-binding", to: "/api/weishop/region/store/wechat-merchant-binding" },
	{ from: "/api/weishop/admin/plugin/cashier/setting/index", to: "/api/weishop/region/plugin/cashier/setting/index" },
	{ from: "/api/weishop/admin/plugin/cashier/setting/store", to: "/api/weishop/region/plugin/cashier/setting/store" },
	{ from: "/api/weishop/admin/plugin/cashier/user/index", to: "/api/weishop/region/plugin/cashier/user/index" },
	{ from: "/api/weishop/admin/plugin/cashier/user/detail", to: "/api/weishop/region/plugin/cashier/user/detail" },
	{ from: "/api/weishop/admin/plugin/cashier/user/store", to: "/api/weishop/region/plugin/cashier/user/store" },
	{ from: "/api/weishop/admin/plugin/cashier/user/del", to: "/api/weishop/region/plugin/cashier/user/del" },
	{ from: "/api/weishop/admin/plugin/cashier/order/index", to: "/api/weishop/region/plugin/cashier/order/index" },
	{ from: "/api/weishop/admin/plugin/cashier/order/detail", to: "/api/weishop/region/plugin/cashier/order/detail" },
	{ from: "/api/weishop/admin/plugin/cashier/balance/index", to: "/api/weishop/region/plugin/cashier/balance/index" },
	{ from: "/api/weishop/admin/plugin/cashier/handover/index", to: "/api/weishop/region/plugin/cashier/handover/index" },
	{ from: "/api/weishop/admin/plugin/cashier/handover/detail", to: "/api/weishop/region/plugin/cashier/handover/detail" },
	{ from: "/api/weishop/admin/plugin/cashier/data/index", to: "/api/weishop/region/plugin/cashier/data/index" },
	{ from: "/api/weishop/admin/plugin/cashier/data/detail", to: "/api/weishop/region/plugin/cashier/data/detail" },
	{ from: "/api/weishop/admin/plugin/rider/user/index", to: "/api/weishop/region/plugin/rider/user/index" },
	{ from: "/api/weishop/admin/plugin/rider/user/detail", to: "/api/weishop/region/plugin/rider/user/detail" },
	{ from: "/api/weishop/admin/plugin/rider/user/change", to: "/api/weishop/region/plugin/rider/user/change" },
	{ from: "/api/weishop/admin/plugin/rider/user/store", to: "/api/weishop/region/plugin/rider/user/store" },
	{ from: "/api/weishop/admin/plugin/rider/user/del", to: "/api/weishop/region/plugin/rider/user/del" },
	{ from: "/api/weishop/admin/plugin/rider/setting/detail", to: "/api/weishop/region/plugin/rider/setting/detail" },
	{ from: "/api/weishop/admin/plugin/rider/setting/save", to: "/api/weishop/region/plugin/rider/setting/save" },
	{ from: "/api/weishop/admin/plugin/rider/event/order", to: "/api/weishop/region/plugin/rider/event/order" },
	{ from: "/api/weishop/admin/plugin/rider/exception/index", to: "/api/weishop/region/plugin/rider/exception/index" },
	{ from: "/api/weishop/admin/plugin/rider/exception/detail", to: "/api/weishop/region/plugin/rider/exception/detail" },
	{ from: "/api/weishop/admin/plugin/rider/exception/handle", to: "/api/weishop/region/plugin/rider/exception/handle" },
	{ from: "/api/weishop/admin/plugin/rider/commission/index", to: "/api/weishop/region/plugin/rider/commission/index" },
	{ from: "/api/weishop/admin/plugin/rider/balance/index", to: "/api/weishop/region/plugin/rider/balance/index" },
	{ from: "/api/weishop/admin/plugin/distribution/goods", to: "/api/weishop/region/plugin/distribution/goods" },
	{ from: "/api/weishop/store/plugin/distribution/goods", to: "/api/weishop/region/plugin/distribution/goods" },
	{ from: "/api/weishop/admin/plugin/distribution/level/index", to: "/api/weishop/region/plugin/distribution/level/index" },
	{ from: "/api/weishop/store/plugin/distribution/level/index", to: "/api/weishop/region/plugin/distribution/level/index" },
	{ from: "/api/weishop/admin/plugin/distribution/level/detail", to: "/api/weishop/region/plugin/distribution/level/detail" },
	{ from: "/api/weishop/store/plugin/distribution/level/detail", to: "/api/weishop/region/plugin/distribution/level/detail" },
	{ from: "/api/weishop/admin/plugin/distribution/user/child", to: "/api/weishop/region/plugin/distribution/user/child" },
	{ from: "/api/weishop/store/plugin/distribution/user/child", to: "/api/weishop/region/plugin/distribution/user/child" },
	{ from: "/api/weishop/admin/plugin/distribution/index/index", to: "/api/weishop/region/plugin/distribution/index/index" },
	{ from: "/api/weishop/store/plugin/distribution/index/index", to: "/api/weishop/region/plugin/distribution/index/index" },
	{ from: "/api/weishop/admin/plugin/distribution/index/curve_index", to: "/api/weishop/region/plugin/distribution/index/curve_index" },
	{ from: "/api/weishop/store/plugin/distribution/index/curve_index", to: "/api/weishop/region/plugin/distribution/index/curve_index" },
	{ from: "/api/weishop/admin/plugin/distribution/index/commission_top", to: "/api/weishop/region/plugin/distribution/index/commission_top" },
	{ from: "/api/weishop/store/plugin/distribution/index/commission_top", to: "/api/weishop/region/plugin/distribution/index/commission_top" },
	{ from: "/api/weishop/admin/plugin/distribution/index/invite_top", to: "/api/weishop/region/plugin/distribution/index/invite_top" },
	{ from: "/api/weishop/store/plugin/distribution/index/invite_top", to: "/api/weishop/region/plugin/distribution/index/invite_top" },
	{ from: "/api/weishop/admin/plugin/distribution/index/goods_top", to: "/api/weishop/region/plugin/distribution/index/goods_top" },
	{ from: "/api/weishop/store/plugin/distribution/index/goods_top", to: "/api/weishop/region/plugin/distribution/index/goods_top" },
	{ from: "/api/weishop/admin/plugin/distribution/user/index", to: "/api/weishop/region/plugin/distribution/user/index" },
	{ from: "/api/weishop/store/plugin/distribution/user/index", to: "/api/weishop/region/plugin/distribution/user/index" },
	{ from: "/api/weishop/admin/plugin/distribution/order/index", to: "/api/weishop/region/plugin/distribution/order/index" },
	{ from: "/api/weishop/store/plugin/distribution/order/index", to: "/api/weishop/region/plugin/distribution/order/index" },
	{ from: "/api/weishop/admin/plugin/distribution/order/detail", to: "/api/weishop/region/plugin/distribution/order/detail" },
	{ from: "/api/weishop/store/plugin/distribution/order/detail", to: "/api/weishop/region/plugin/distribution/order/detail" },
	{ from: "/api/weishop/admin/plugin/distribution/withdrawal/index", to: "/api/weishop/region/plugin/distribution/withdrawal/index" },
	{ from: "/api/weishop/store/plugin/distribution/withdrawal/index", to: "/api/weishop/region/plugin/distribution/withdrawal/index" },
	{ from: "/api/weishop/admin/plugin/shareholder/setting/index", to: "/api/weishop/region/plugin/shareholder/setting/index" },
	{ from: "/api/weishop/admin/plugin/shareholder/level/index", to: "/api/weishop/region/plugin/shareholder/level/index" },
	{ from: "/api/weishop/admin/plugin/shareholder/user/index", to: "/api/weishop/region/plugin/shareholder/user/index" },
	{ from: "/api/weishop/admin/plugin/shareholder/order/index", to: "/api/weishop/region/plugin/shareholder/order/index" },
	{ from: "/api/weishop/store/plugin/shareholder/order/index", to: "/api/weishop/region/plugin/shareholder/order/index" },
	{ from: "/api/weishop/admin/plugin/shareholder/order/detail", to: "/api/weishop/region/plugin/shareholder/order/detail" },
	{ from: "/api/weishop/store/plugin/shareholder/order/detail", to: "/api/weishop/region/plugin/shareholder/order/detail" },
	{ from: "/api/weishop/admin/plugin/shareholder/dividend/index", to: "/api/weishop/region/plugin/shareholder/dividend/index" },
	{ from: "/api/weishop/admin/plugin/shareholder/withdrawal/index", to: "/api/weishop/region/plugin/shareholder/withdrawal/index" },
	{ from: "/api/weishop/admin/plugin/shareholder/withdrawal/detail", to: "/api/weishop/region/plugin/shareholder/withdrawal/detail" },
	{ from: "/api/weishop/admin/plugin/shareholder/index/curve_index", to: "/api/weishop/region/plugin/shareholder/index/curve_index" },
	{ from: "/api/weishop/admin/plugin/stockholder/level/index", to: "/api/weishop/region/plugin/stockholder/level/index" },
	{ from: "/api/weishop/admin/plugin/stockholder/user/index", to: "/api/weishop/region/plugin/stockholder/user/index" },
	{ from: "/api/weishop/admin/plugin/stockholder/order/index", to: "/api/weishop/region/plugin/stockholder/order/index" },
	{ from: "/api/weishop/admin/plugin/stockholder/order/detail", to: "/api/weishop/region/plugin/stockholder/order/detail" },
	{ from: "/api/weishop/admin/plugin/stockholder/dividend/index", to: "/api/weishop/region/plugin/stockholder/dividend/index" },
	{ from: "/api/weishop/admin/plugin/stockholder/withdrawal/index", to: "/api/weishop/region/plugin/stockholder/withdrawal/index" },
	{ from: "/api/weishop/admin/plugin/stockholder/index/index", to: "/api/weishop/region/plugin/stockholder/index/index" },
	{ from: "/api/weishop/admin/plugin/stockholder/index/level_top", to: "/api/weishop/region/plugin/stockholder/index/level_top" },
	{ from: "/api/weishop/admin/plugin/stockholder/index/user_top", to: "/api/weishop/region/plugin/stockholder/index/user_top" },
	{ from: "/api/weishop/admin/plugin/store/deal", to: "/api/weishop/region/plugin/store/deal" },
	{ from: "/api/weishop/admin/plugin/store/information/index", to: "/api/weishop/region/plugin/store/information/index" },
	{ from: "/api/weishop/admin/plugin/store/information/info", to: "/api/weishop/region/plugin/store/information/info" },
	{ from: "/api/shop/basic/goods/getGoodsList", to: "/api/weishop/region/goods/sync/list" },
	{ from: "/api/shop/basic/plugin-menu", to: "/api/weishop/region/plugin-menu" },
	{ from: "/api/shop/basic/app/plugin-cat-index", to: "/api/weishop/region/app/plugin-cat-index" },
	{ from: "/api/shop/basic/application/operation-index", to: "/api/weishop/region/application/operation-index" },
	{ from: "/api/shop/basic/plugin/summary", to: "/api/weishop/region/plugin/summary" },
	{ from: "/api/shop/basic/store-category", to: "/api/weishop/region/store-category" },
	{ from: "/api/shop/basic/store-label", to: "/api/weishop/region/store-label" },
	{ from: "/api/shop/basic/store-index", to: "/api/weishop/region/store-index" },
	{ from: "/api/shop/basic/store-addStoreDetail", to: "/api/weishop/region/store-addStoreDetail" },
	{ from: "/api/shop/basic/wechat/live_stream/index", to: "/api/weishop/region/wechat/live_stream/index" },
	{ from: "/api/shop/basic/ledger/lakala", to: "/api/weishop/region/finance/ledger/lakala" },
	{ from: "/api/shop/basic/ledger/receiver", to: "/api/weishop/region/finance/ledger/receiver" },
	{ from: "/api/shop/basic/store/withdraw-query", to: "/api/weishop/region/finance/store/withdraw-query" },
	{ from: "/api/shop/basic/store/withdrawal-check", to: "/api/weishop/region/finance/store/withdrawal-check" },
	{ from: "/api/shop/basic/store/withdrawal-pay", to: "/api/weishop/region/finance/store/withdrawal-pay" },
	{ from: "/api/shop/basic/shop-info", to: "/api/weishop/region/common_account/shop-info" },
	{ from: "/api/weishop/store/finance/index", to: "/api/weishop/region/finance/index" },
	{ from: "/api/weishop/store/balance/index", to: "/api/weishop/region/finance/balance/index" },
	{ from: "/api/weishop/store/revenue/index", to: "/api/weishop/region/finance/revenue/index" },
	{ from: "/api/weishop/store/withdrawal/index", to: "/api/weishop/region/finance/withdrawal/index" },
	{ from: "/api/weishop/store/order/finish/list", to: "/api/weishop/region/finance/order/finish/list" },
	{ from: "/api/weishop/store/user/settle_apply_show", to: "/api/weishop/region/finance/settlement/show" },
	{ from: "/api/weishop/store/user/settle_apply", to: "/api/weishop/region/finance/settlement/apply" },
	{ from: "/api/shop/basic/application/log-index", to: "/api/weishop/region/overview/application/log-index" },
	{ from: "/api/shop/basic/revenue/index", to: "/api/weishop/region/record/revenue/index" },
	{ from: "/api/shop/basic/password-change", to: "/api/weishop/region/common_account/password-change" },
	{ from: "/api/shop/basic/mobile-change", to: "/api/weishop/region/common_account/mobile-change" },
	{ from: "/api/shop/basic/setting-index", to: "/api/weishop/region/common_account/setting-index" },
	{ from: "/api/shop/basic/setting-store", to: "/api/weishop/region/common_account/setting-store" },
	{ from: "/api/shop/basic/shop-save", to: "/api/weishop/region/common_account/shop-save" },
	{ from: "/api/shop/basic/user-info", to: "/api/weishop/region/common_account/user-info" },
	{ from: "/api/shop/basic/pwd-day", to: "/api/weishop/region/common_account/pwd-day" },
	{ from: "/api/common/shop/admin/upload/setting/index", to: "/api/weishop/region/common_account/upload/setting/index" },
	{ from: "/api/weishop/admin/statistics", to: "/api/weishop/region/statistics" },
	{ from: "/api/weishop/admin/setting", to: "/api/weishop/region/setting" },
	{ from: "/api/weishop/store/setting", to: "/api/weishop/region/setting" },
	{ from: "/api/weishop/store/store/address", to: "/api/weishop/region/store/address" },
	{ from: "/api/weishop/store/store/index", to: "/api/weishop/region/store/store/index" },
	{ from: "/api/weishop/store/store/basic/update", to: "/api/weishop/region/store/store/basic/update" },
	{ from: "/api/weishop/store/store/business/update", to: "/api/weishop/region/store/store/business/update" },
	{ from: "/api/weishop/store/store/city/update", to: "/api/weishop/region/store/store/city/update" },
	{ from: "/api/weishop/admin/store", to: "/api/weishop/region/store" },
	{ from: "/api/weishop/admin/door/setting", to: "/api/weishop/region/door/setting" },
	{ from: "/api/weishop/admin/order", to: "/api/weishop/region/order" },
	{ from: "/api/weishop/store/order", to: "/api/weishop/region/order" },
	{ from: "/api/weishop/admin/goods", to: "/api/weishop/region/goods" },
	{ from: "/api/weishop/store/goods", to: "/api/weishop/region/goods" },
	{ from: "/api/weishop/admin/user", to: "/api/weishop/region/user" },
	{ from: "/api/weishop/store/user", to: "/api/weishop/region/user" },
	{ from: "/api/weishop/admin/category", to: "/api/weishop/region/category" },
	{ from: "/api/weishop/store/category", to: "/api/weishop/region/category" },
	{ from: "/api/weishop/admin/home/data", to: "/api/weishop/region/home/data" },
];

export const safePassthroughRules = [
	/^\/api\/common\/(?!shop\/admin\/upload\/setting\/index(?:[/?#]|$))/,
	/^\/api\/weishop\/admin\/region\/tree(?:[?#]|$)/,
];

export const pluginPassthroughRules = [
];

export const blockedRegionRules = [
	{
		rule: /^\/api\/weishop\/(admin|store)\/plugin\/distribution\/(?!goods(?:[/?#]|$)|level\/index(?:[?#]|$)|level\/detail\/[^/?#]+(?:[?#]|$)|user\/child(?:[/?#]|$)|user\/index(?:[?#]|$)|order\/index(?:[?#]|$)|order\/detail\/[^/?#]+(?:[?#]|$)|index\/(?:index|curve_index|commission_top|invite_top|goods_top)(?:[?#]|$)|withdrawal\/index(?:[?#]|$))/,
		message: "区域账号暂未开放该分销插件接口，请使用总店/门店账号处理",
	},
	{
		rule: /^\/api\/weishop\/(admin|store)\/plugin\/distribution\/withdrawal\/(?!index(?:[?#]|$))/,
		message: "区域账号暂未开放分销提现管理，请使用总店/门店账号处理",
	},
	{
		rule: /^\/api\/shop\/basic\/user\/withdrawal-pay(?:[/?#]|$)/,
		message: "区域账号暂未开放分销提现打款，请使用总店/门店账号处理",
	},
	{
		rule: /^\/api\/weishop\/admin\/plugin\/cashier\//,
		allowRules: [
			/^\/api\/weishop\/admin\/plugin\/cashier\/setting\/(index|store)(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/cashier\/user\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/cashier\/user\/detail\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/cashier\/user\/store(?:\/[^/?#]+)?(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/cashier\/user\/del\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/cashier\/order\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/cashier\/order\/detail\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/cashier\/balance\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/cashier\/handover\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/cashier\/handover\/detail\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/cashier\/data\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/cashier\/data\/detail\/[^/?#]+(?:[?#]|$)/,
		],
		message: "区域账号暂未开放收银台插件接口，请使用总店/门店账号处理",
	},
	{
		rule: /^\/api\/weishop\/admin\/plugin\/rider\//,
		allowRules: [
			/^\/api\/weishop\/admin\/plugin\/rider\/user\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/rider\/user\/detail\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/rider\/user\/change\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/rider\/user\/store(?:\/[^/?#]+)?(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/rider\/user\/del\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/rider\/setting\/(detail|save)(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/rider\/event\/order\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/rider\/exception\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/rider\/exception\/detail\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/rider\/exception\/handle\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/rider\/commission\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/rider\/balance\/index(?:[?#]|$)/,
		],
		message: "区域账号暂未开放配送员插件，请使用总店/门店账号处理",
	},
	{
		rule: /^\/api\/weishop\/admin\/plugin\/wechat-transfer\//,
		message: "区域账号暂未开放微信转账插件，请使用总店/门店账号处理",
	},
	{
		rule: /^\/api\/weishop\/admin\/plugin\/stockholder\//,
		allowRules: [
			/^\/api\/weishop\/admin\/plugin\/stockholder\/level\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/stockholder\/user\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/stockholder\/order\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/stockholder\/order\/detail\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/stockholder\/dividend\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/stockholder\/withdrawal\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/stockholder\/index\/(index|level_top|user_top)(?:[?#]|$)/,
		],
		message: "区域账号暂未开放股东分红插件，请使用总店账号处理",
	},
	{
		rule: /^\/api\/weishop\/(admin|store)\/plugin\/shareholder\//,
		allowRules: [
			/^\/api\/weishop\/admin\/plugin\/shareholder\/setting\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/shareholder\/level\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/shareholder\/user\/index(?:[?#]|$)/,
			/^\/api\/weishop\/(admin|store)\/plugin\/shareholder\/order\/index(?:[?#]|$)/,
			/^\/api\/weishop\/(admin|store)\/plugin\/shareholder\/order\/detail\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/shareholder\/dividend\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/shareholder\/withdrawal\/index(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/shareholder\/withdrawal\/detail\/[^/?#]+(?:[?#]|$)/,
			/^\/api\/weishop\/admin\/plugin\/shareholder\/index\/curve_index(?:[?#]|$)/,
		],
		message: "区域账号暂未开放股东分红插件，请使用总店账号处理",
	},
];

export const excludedRules = [
	/^\/api\/house\//,
	/^\/api\/erp\//,
	/^\/api\/weishop\/admin\/plugin\/erp\//,
	/^\/api\/weishop\/admin\/plugin\/inventory\//,
	/^\/api\/weishop\/store\/plugin\/inventory\//,
	/^\/api\/weishop\/region\/application\/inventory\//,
];

function isStringUrl(url) {
	return typeof url === "string";
}

function isRuleHit(url, from) {
	return url === from || url.indexOf(from + "/") === 0 || url.indexOf(from + "?") === 0 || url.indexOf(from + "#") === 0;
}

function ruleListHit(rules, url) {
	return rules.some((rule) => rule.test(url));
}

function blockedRuleHit(url) {
	return blockedRegionRules.find((item) => item.rule.test(url) && !ruleListHit(item.allowRules || [], url));
}

function getSessionValue(key) {
	try {
		return sessionStorage.getItem(key);
	} catch (error) {
		return "";
	}
}

function currentRoutePath() {
	if (typeof window === "undefined" || !window.location) {
		return "";
	}

	const hash = window.location.hash || "";
	if (hash.indexOf("#") !== 0) {
		return "";
	}

	return hash.slice(1).split("?")[0].split("#")[0] || "";
}

function isRegionRoute() {
	const path = currentRoutePath();
	return path === "/region" || path.indexOf("/region/") === 0;
}

export function isRegionScope() {
	// 区域账号登录状态会在同域 session 中残留，必须同时校验当前路由，避免普通店铺页接口被误映射到区域 facade。
	return getSessionValue("accountScope") === "region" && isRegionRoute();
}

export function resolveWeiShopApi(url) {
	if (!isStringUrl(url)) {
		return url;
	}
	if (!isRegionScope()) {
		return url;
	}
	if (ruleListHit(excludedRules, url)) {
		throw new Error(`区域账号不支持该仓储/ERP接口: ${url}`);
	}
	const blockedRule = blockedRuleHit(url);
	if (blockedRule) {
		throw new Error(`${blockedRule.message}: ${url}`);
	}
	if (ruleListHit(safePassthroughRules, url) || ruleListHit(pluginPassthroughRules, url)) {
		return url;
	}

	const hit = regionMap.find((item) => isRuleHit(url, item.from));
	if (hit) {
		return url.replace(hit.from, hit.to);
	}

	if (/^\/api\/weishop\/(store|admin)\//.test(url)) {
		throw new Error(`区域账号接口未纳入覆盖矩阵: ${url}`);
	}
	if (/^\/api\/shop\/basic\//.test(url)) {
		throw new Error(`区域账号接口未纳入覆盖矩阵: ${url}`);
	}

	return url;
}
